import SvgIcon, { SvgIconProps } from "./SvgIcon";

const QuickLessonIcon: React.FC<SvgIconProps> = ({
  variant = "contained",
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "contained" ? (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1493 10.741L13.2093 13.681C13.0693 13.831 12.8693 13.901 12.6793 13.901C12.4893 13.901 12.2993 13.831 12.1493 13.681C11.8593 13.391 11.8593 12.911 12.1493 12.621L15.0893 9.681C15.3893 9.391 15.8593 9.391 16.1493 9.681C16.4493 9.971 16.4493 10.451 16.1493 10.741ZM12.6893 5.021C8.1893 5.021 4.5293 8.681 4.5293 13.181C4.5293 13.2833 4.53192 13.3857 4.53582 13.4867C4.54197 13.6461 4.67437 13.771 4.83393 13.771H8.1893C9.2993 13.771 10.1893 14.661 10.1893 15.771C10.1893 15.8206 10.1872 15.8695 10.1833 15.9177C10.1671 16.1173 10.3099 16.311 10.5102 16.311H10.6793C11.7793 16.311 12.6793 17.201 12.6793 18.311C12.6793 18.4795 12.6572 18.6448 12.6166 18.8035C12.5726 18.9754 12.6918 19.161 12.8693 19.161C13.8023 19.161 14.5882 19.8041 14.8039 20.6743C14.8499 20.8597 15.0333 20.9933 15.215 20.9342C18.4824 19.871 20.8493 16.8009 20.8493 13.181C20.8493 8.681 17.1893 5.021 12.6893 5.021Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5918 3.58936H14.7998C15.2138 3.58936 15.5498 3.25336 15.5498 2.83936C15.5498 2.42536 15.2138 2.08936 14.7998 2.08936H10.5918C10.1778 2.08936 9.8418 2.42536 9.8418 2.83936C9.8418 3.25336 10.1778 3.58936 10.5918 3.58936Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4248 18.3096C11.4248 17.8956 11.0888 17.5596 10.6747 17.5596H6.38379C5.96979 17.5596 5.63379 17.8956 5.63379 18.3096C5.63379 18.7236 5.96979 19.0596 6.38379 19.0596H10.6747C11.0888 19.0596 11.4248 18.7236 11.4248 18.3096Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8642 20.4106H8.57324C8.15924 20.4106 7.82324 20.7466 7.82324 21.1606C7.82324 21.5746 8.15924 21.9106 8.57324 21.9106H12.8642C13.2782 21.9106 13.6142 21.5746 13.6142 21.1606C13.6142 20.7466 13.2782 20.4106 12.8642 20.4106Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.94288 15.7695C8.94288 15.3555 8.60688 15.0195 8.19288 15.0195H3.90088C3.48688 15.0195 3.15088 15.3555 3.15088 15.7695C3.15088 16.1835 3.48688 16.5195 3.90088 16.5195H8.19288C8.60688 16.5195 8.94288 16.1835 8.94288 15.7695Z"
            fill="currentColor"
          />
        </>
      ) : (
        <>
          <path
            d="M8.66952 21.0006L12.638 20.9986C16.8683 20.9986 20.2974 17.5665 20.2974 13.3362C20.2974 9.10593 16.8683 5.67578 12.638 5.67578C8.40671 5.67578 4.97754 9.10593 4.97754 13.3362"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M6.18555 18.4668H10.4774"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M3.70312 15.9336H7.99496"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M10.5352 3H14.742"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M12.627 13.3079L15.5676 10.3672"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default QuickLessonIcon;
